import moment from 'jalali-moment'

export const DigitToMonth: { [key: number]: string } = {
    1: 'فروردین',
    2: 'اردیبهشت',
    3: 'خرداد',
    4: 'تیر',
    5: 'مرداد',
    6: 'شهریور',
    7: 'مهر',
    8: 'آبان',
    9: 'آذر',
    10: 'دی',
    11: 'بهمن',
    12: 'اسفند',
}
export const ConvertJalaliDate = (date: string) => {
    const day: string = moment.from(date, 'fa', 'jYYYY-jM-jD').format('jD')
    const month: string = moment.from(date, 'fa', 'jYYYY-jM-jD').format('jM')
    const year: string = moment.from(date, 'fa', 'jYYYY-jM-jD').format('jYYYY')
    const result: string =
        Number(day) + ' ' + DigitToMonth[Number(month)] + ' ' + Number(year)
    return result
}

export const ConvertorMiladi = (date: string) => {
    const day: string = moment
        .from(date, 'en', 'YYYY-M-D')
        .locale('fa')
        .format('D')
    const month: string = moment
        .from(date, 'en', 'YYYY-M-D')
        .locale('fa')
        .format('M')
    const year: string = moment
        .from(date, 'en', 'YYYY-M-D')
        .locale('fa')
        .format('YYYY')
    const result: string =
        Number(day) + ' ' + DigitToMonth[Number(month)] + ' ' + Number(year)
    return result
}
